import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAS0lEQVR42mXLOwrAIBAEUO/fJ9jkB+lCLqagLrY646cQwYVtZt4oThdDYBSZo6RG6T2/6+B/nx0uwBnDZ9/4ak1n7QoAUOqyPTIGKFiGeXiLljT5AAAAAElFTkSuQmCC"};
